module.exports = __webpack_public_path__ + "img/farzana-christopher-61.b141a8cc.jpg";